import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import constants from 'src/app/shared/constants';


export class TAndCReturnData {
    request_id = '';
    terms = false;

    constructor(data) {
        this.request_id = data['request_id'];
        this.terms = data['terms'];
    }
}

@Component({
    selector: 'xlog-t-and-c-request-box',
    templateUrl: './t-and-c-request-box.component.pug',
    styleUrls: ['./t-and-c-request-box.component.scss'],
    standalone: false
})

export class TAndCRequestBoxComponent implements OnInit {

    @Input() request_id: string;
    @Output() tAndCAccepted: EventEmitter<TAndCReturnData> = new EventEmitter<TAndCReturnData>();
    @Input() t_and_c_url: string;
    privacy_url: string = constants.PRIVACY_URL;

    setTAndCForm = this.fb.group({
        request_id: ['', Validators.required],
        terms: [false, [Validators.requiredTrue]],
    });
    constructor(private fb: UntypedFormBuilder) { }

    ngOnInit() {
        this.setTAndCForm.patchValue({
            request_id: this.request_id
        });
    }

    goBack() {
        location.replace('/');
    }

    submit() {
        const data = {
            'request_id': this.setTAndCForm.controls['request_id'].value,
            'terms': this.setTAndCForm.controls['terms'].value
        };
        this.tAndCAccepted.emit(new TAndCReturnData(data));
    }
}
